// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "460" ? "quickjs-sandbox" : chunkId) + "." + {"396": "490effede402c6cc","460": "b9c1cbffcf8d9516","917": "a465bf2c9ac48138","985": "c5bf5e2c41709d95",}[chunkId] + ".chunk.js"
}